import React, { FC } from 'react';
import { Avatar, useTectonTheme } from '@lithos';

interface WorkspaceIconProps {
  workspaceType: 'Live' | 'Development';
}

const WorkspaceIcon: FC<WorkspaceIconProps> = ({ workspaceType }) => {
  const { theme } = useTectonTheme();

  return (
    <Avatar
      square
      type="icon"
      icon={workspaceType === 'Live' ? 'ProductionWorkspace' : 'DevelopmentWorkspace'}
      size="m"
      color={workspaceType === 'Live' ? theme.v1.colors.viz['5-yellow'].text : theme.v1.colors.viz['10-green'].text}
      backgroundColor={
        workspaceType === 'Live'
          ? theme.v1.colors.viz['5-yellow'].behindText
          : theme.v1.colors.viz['10-green'].behindText
      }
    />
  );
};

export default WorkspaceIcon;
